export default "__VITE_ASSET__DdwWmUa7__"